// React
import { FunctionComponent } from "react";
// Library
import { Title } from "@fyrstain/fhir-front-library";
// Components
import ApolloPage from "../../components/ApolloPage/ApolloPage";
// Styles
import styles from "./Home.module.css";

const Home: FunctionComponent = () => {
    return (
        <ApolloPage loading={false} needsLogin={false}>
            <>
                <div className={styles.mainHomeContainer}>
                    <img
                        className={styles.homeimageIcon}
                        alt="Home_image"
                        src={(process.env.PUBLIC_URL ?? "") + "/assets/home_diagnostic_reports.png"}
                    />
                    <Title level={1} prefix={'Apollo'} />
                </div>
            </>
        </ApolloPage>
    );
};

export default Home;
